import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Payments = () => {
    document.title = "Mədaxil & Məxaric";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Mədaxil & Məxaric", value: "/cash/payments", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Mədaxil & Məxaric</h2>
                    <p>
                        <b>Kassa mədaxil</b> ilə administrator tərəfindən kassaya daxil edilən pul qeyd edilə bilər. Kassa mədaxil əməliyyatı zamanı Sahibkar
                        balansı azalır, kassa balansı artır.
                        <br />
                        <b>Kassa məxaric</b> əməliyyatı ilə administrator tərəfindən kassadan çıxarılan pulu qeyd etmək olar. Bu zaman, kassa balansı azalır,
                        sahibkar balansı isə artır.
                    </p>
                    <img src="/images/cash/payments.gif" alt="Mədaxil & Məxaric" />
                </article>
            </div>
        </div>
    );
};
